<template>
  <div class="entity role">
    <sui-form-fields>
      <EntityInput :width="8" v-model="entity.name" fieldName="name" ref="name" v-if="visibleFields.name" />
      <sui-form-field :width="8">
        <label>Copy from</label>
        <sui-dropdown selection search placeholder="Select..." v-model="selectedTemplate" :options="templates" />
      </sui-form-field>
    </sui-form-fields>
    <EntityActions v-model="entity.actions" fieldName="actions" ref="actions" v-if="visibleFields.actions" />
  </div>
</template>

<script>
  import EntityActions from '@/components/forms/EntityActions'
  import EntityInput from '@/components/forms/EntityInput'
  import FormAccess from '@/mixins/FormAccess'
  import FormEntity from '@/mixins/FormEntity'

  export default {
    name: 'FormRole',
    mixins: [
      FormAccess,
      FormEntity,
    ],
    components: {
      EntityActions,
      EntityInput,
    },
    data() {
      return {
        object: 'Role',
        commonFields: ['name'],
        cloneFrom: 'empty',
      }
    },
  }
</script>
